//To open the coupon drawer
(function () {
  const discountButton = document.querySelector('.apply_discount__button');
  const Coupondrawer = document.querySelector('.coupon_drawer__main_container');
  const closeCouponBtn = document.querySelector('.coupon_close__drawer');

  if (!discountButton || !Coupondrawer || !closeCouponBtn) return;

  discountButton.addEventListener('click', function (e) {
      e.stopPropagation();
      Coupondrawer.classList.add('activeCoupon');
  });

  Coupondrawer.addEventListener('click', function (e) {
      e.stopPropagation();
  });

  closeCouponBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      Coupondrawer.classList.remove('activeCoupon');
  });

  document.addEventListener('click', function () {
    if (Coupondrawer.classList.contains('activeCoupon')) {
        return;
    }
  });
})();

//Tab switching for offers tab
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll('.coupon_drawer_tab');
  const offers = document.querySelectorAll('.coupon_drawer__offer_info');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const selectedId = tab.id.toLowerCase();

      tabs.forEach(t => t.classList.remove('active_tab'));
      tab.classList.add('active_tab');

      if (selectedId === 'all') {
        offers.forEach(offer => offer.style.display = 'block');
      } else {
        offers.forEach(offer => {
          offer.style.display = (offer.id.toLowerCase() === selectedId) ? 'block' : 'none';
        });
      }
    });
  });
  
  const defaultTab = document.querySelector('#all') || tabs[0];
  if (defaultTab) defaultTab.click();
});

//To update tap to apply button
document.addEventListener("DOMContentLoaded", function () {
  const subtotalElement = document.querySelector('[data-subtotal]');
  const platformFeeElement = document.querySelector('[data-platform-fee]');
  const netTotalElement = document.querySelector('[data-net-total]');
  const couponOffers = document.querySelectorAll('.coupon_drawer__offer_info');

  function getNumericValue(element) {
    if (!element) return 0;
    const text = element.textContent.replace(/[^\d.]/g, '');
    return text ? parseFloat(text) : 0;
  }

  function updateCouponDrawerOffers() {
  const subtotal = getNumericValue(subtotalElement);
  const platformFee = getNumericValue(platformFeeElement);
  const netTotal = subtotal + platformFee;

  const appliedCode = localStorage.getItem("appliedDiscountCode");
  let isValid = false;

  

  couponOffers.forEach(offer => {
    const threshold = parseFloat(offer.getAttribute('data-threshold')) || 0;
    const button = offer.querySelector('.coupon_drawer__discount_button');
    const code = offer.querySelector('.coupon_drawer__discount_code')?.textContent.trim();

    if (threshold <= subtotal) {
      button.classList.remove('disabled');
      button.setAttribute('aria-disabled', 'false');
      button.style.pointerEvents = 'auto';
      button.style.opacity = '1';


      if (code === appliedCode) {
        isValid = true;
      }
    } else {
      button.classList.add('disabled');
      button.setAttribute('aria-disabled', 'true');
      button.style.pointerEvents = 'none';
      button.style.opacity = '0.5';
      button.innerHTML = 'Shop more to avail';

      
    }
  });



  // Automatically remove discount if it no longer qualifies
  if (appliedCode && !isValid) {
    localStorage.removeItem("appliedDiscountCode");

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = `/discount/clear`;
    document.body.appendChild(iframe);

    setTimeout(() => {
      const banner = document.getElementById("applied-discount-banner");
      const codeText = document.getElementById("applied-discount-code");
      if (banner && codeText) {
        codeText.textContent = "";
        banner.style.display = "none";
      }
      document.querySelectorAll(".coupon_drawer__discount_button").forEach(btn => {
        btn.classList.remove("applied");
        btn.textContent = "Apply coupon";
      });
      document.body.removeChild(iframe);
    }, 1000);
  }
}


  const observer = new MutationObserver(updateCouponDrawerOffers);
  if (subtotalElement) observer.observe(subtotalElement, { childList: true, subtree: true });
  if (platformFeeElement) observer.observe(platformFeeElement, { childList: true, subtree: true });

  updateCouponDrawerOffers();
});

//To update applied discount
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".coupon_drawer__discount_button");
  const banner = document.getElementById("applied-discount-banner");
  const codeText = document.getElementById("applied-discount-code");
  const removeBtn = document.getElementById("remove-discount");

  function openCartDrawer() {
    if (typeof theme.CartDrawer !== "undefined") {
      const cartDrawer = new theme.CartDrawer();
      cartDrawer.open();
      document.dispatchEvent(new Event("cart:open"));
    }
  }

  function applyDiscount(code) {
    localStorage.setItem("appliedDiscountCode", code);

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = `/discount/${code}`;
    document.body.appendChild(iframe);

    setTimeout(() => {
      showBanner(code);
      updateButtonStates(code);
      openCartDrawer();
      document.body.removeChild(iframe);
    }, 1000);
  }

  function removeDiscount() {
    localStorage.removeItem("appliedDiscountCode");

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = `/discount/clear`;
    document.body.appendChild(iframe);

    setTimeout(() => {
      hideBanner();
      updateButtonStates(null); // Clear applied styles
      openCartDrawer();
      document.body.removeChild(iframe);
    }, 1000);
  }

  function showBanner(code) {
    if (banner && codeText) {
      codeText.textContent = `${code}`;
      banner.style.display = "block";
    }
  }

  function hideBanner() {
    if (banner && codeText) {
      codeText.textContent = "";
      banner.style.display = "none";
    }
  }

  function updateButtonStates(appliedCode) {
    buttons.forEach(button => {
      const offer = button.closest(".coupon_drawer__offer_info");
      const code = offer?.querySelector(".coupon_drawer__discount_code")?.textContent.trim();

      if (code === appliedCode) {
        button.classList.add("applied");
        button.innerHTML = "Applied";
      } else {
        button.classList.remove("applied");
        button.textContent = "Apply coupon";
      }
    });
  }

  // Attach click handlers
  buttons.forEach(button => {
    button.addEventListener("click", function () {
      const offer = button.closest(".coupon_drawer__offer_info");
      if (!offer) return;

      const code = offer.querySelector(".coupon_drawer__discount_code")?.textContent.trim();
      if (!code) return;

      applyDiscount(code);
    });
  });


  if (removeBtn) {
    removeBtn.addEventListener("click", function () {
      removeDiscount();
    });
  }

  const savedCode = localStorage.getItem("appliedDiscountCode");

    if (savedCode) {
      showBanner(savedCode);
      updateButtonStates(savedCode);
    }
   else if (savedCode) {
    showBanner(savedCode);
    updateButtonStates(savedCode);
  }
});